import { comparisonMinutes } from "../../../../../lib/format-time/precision.mjs"

export function createComparableTask(task) {
    const count = Number.isFinite(task.count) && task.count > 0 ? task.count : 1
    // The editor rounds per-unit durations before quantities are applied.
    const minutes =
        typeof task.minutes === "number" && Number.isFinite(task.minutes)
            ? comparisonMinutes(task.minutes / count) * count
            : task.minutes
    return {
        classification: task.classification,
        frequency: task.frequency?.label,
        minutes,
        skill: task.skill,
    }
}
